import { TRANSPORT_OPTION_TYPES } from '@common/utils'
import type {
  StoreSlice,
  TransportTypeActions,
  TransportTypeState
} from '../types'

export const createTransportSlice: StoreSlice<
  TransportTypeState & TransportTypeActions
> = set => ({
  // State
  selectedTransportType: TRANSPORT_OPTION_TYPES.DELIVERY,

  // Actions
  setSelectedTransportType: val =>
    set({ selectedTransportType: val }, false, 'setSelectedTransportType')
})
